import React from "react";
import Svg from "@natera/material/lib/svg";

import Visa from "@app/postBill/assets/svg/visa.svg";
import Amex from "@app/postBill/assets/svg/american-express.svg";
import Discover from "@app/postBill/assets/svg/discover.svg";
import MasterCard from "@app/postBill/assets/svg/master-card.svg";
import DinnersClub from "@app/postBill/assets/svg/dinners-club.svg";
import EftPos from "@app/postBill/assets/svg/eftpos.svg";
import Jcb from "@app/postBill/assets/svg/jcb.svg";
import UnionPay from "@app/postBill/assets/svg/union-pay.svg";
import Default from "@app/postBill/assets/svg/default.svg";
import { defineMessages, useIntl } from "react-intl";
import { PaymentCardBrand } from "@app/postBill/models";
import { PaymentMethodSummaryObject } from "@app/ups/utils";

import "./upsPaymentFailedCard.scss";

const messages = defineMessages({
  upsPaymentFailedCardTitle: {
    id: "upsPaymentFailedCardTitle",
    defaultMessage: "Failed payment method",
  },
  upsPaymentFailedCardSubtitle: {
    id: "upsPaymentFailedCardSubtitle",
    defaultMessage:
      "Currently used for autopay payment plan ({installmentCount} months)",
  },
});

export interface UPSPaymentFailedCardProps extends PaymentMethodSummaryObject {
  installmentCount: number;
}

const getPaymentCardBrandLogo = (brand: PaymentCardBrand): string => {
  switch (brand) {
    case PaymentCardBrand.VISA:
      return Visa;
    case PaymentCardBrand.AMEX:
      return Amex;
    case PaymentCardBrand.DISCOVER:
      return Discover;
    case PaymentCardBrand.MASTERCARD:
      return MasterCard;
    case PaymentCardBrand.DINERS:
      return DinnersClub;
    case PaymentCardBrand.EFTPOS_AU:
      return EftPos;
    case PaymentCardBrand.JCB:
      return Jcb;
    case PaymentCardBrand.UNIONPAY:
      return UnionPay;
    default:
      return Default;
  }
};

const UPSPaymentFailedCard: React.FC<UPSPaymentFailedCardProps> = ({
  brand,
  last4digits,
  expiry,
  installmentCount,
}) => {
  const intl = useIntl();

  return (
    <div className="ups-payment-failed-card">
      <div className="ups-payment-failed-card__title">
        {intl.formatMessage(messages.upsPaymentFailedCardTitle)}
      </div>
      <div className="ups-payment-failed-card__content">
        <Svg
          className="ups-payment-failed-card__logo"
          content={getPaymentCardBrandLogo(brand)}
        />
        <div className="ups-payment-failed-card__info">
          <div className="ups-payment-failed-card__number">
            •••• {last4digits}
          </div>
          <div className="ups-payment-failed-card__details">
            <span>{expiry}</span>
          </div>
        </div>
      </div>
      <div className="ups-payment-failed-card__subtitle">
        {intl.formatMessage(messages.upsPaymentFailedCardSubtitle, {
          installmentCount,
        })}
      </div>
    </div>
  );
};

export default UPSPaymentFailedCard;
